import type { SVGProps } from 'react';

const SvgPoster = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 14v-4c0-1.65-1.35-3-3-3H9c-1.65 0-3 1.35-3 3v4c0 .06.01.11.02.17v.02C6.12 15.75 7.41 17 9 17h6c1.65 0 3-1.35 3-3M9 9h6c.55 0 1 .45 1 1v.38l-.55-.28a1 1 0 0 0-1 .06l-2.52 1.68-1.48-.74a1 1 0 0 0-1 .06L8 12.12V9.99c0-.55.45-1 1-1zm6 6H9c-.39 0-.71-.23-.88-.55l1.95-1.3 1.48.74c.32.16.7.14 1-.06l2.52-1.68.93.46v1.38c0 .55-.45 1-1 1zM4 8c.55 0 1-.45 1-1V6c0-.55.45-1 1-1h1c.55 0 1-.45 1-1s-.45-1-1-1H6C4.35 3 3 4.35 3 6v1c0 .55.45 1 1 1m3 11H6c-.55 0-1-.45-1-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v1c0 1.65 1.35 3 3 3h1c.55 0 1-.45 1-1s-.45-1-1-1m13-3c-.55 0-1 .45-1 1v1c0 .55-.45 1-1 1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c1.65 0 3-1.35 3-3v-1c0-.55-.45-1-1-1M18 3h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1 .45 1 1v1c0 .55.45 1 1 1s1-.45 1-1V6c0-1.65-1.35-3-3-3"
    />
  </svg>
);
export default SvgPoster;
